var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{staticClass:"absolute",attrs:{"width":"100%","height":"100%","autoplay":"","loop":"","muted":"","playsinline":""},domProps:{"muted":true}},[_vm._l((_vm.sources),function([src, type]){return _c('source',{key:src,attrs:{"src":src,"type":type}})}),_vm._v("\n  Sorry, your browser doesn't support embedded videos.\n")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }